import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import { connect } from "react-redux";
import Modal from "react-modal";
import "../../assets/css/indicatorEop.css";
import { Eop } from "./Eop.jsx";
import { EopVisit } from "./EopVisit.jsx";
import moment from "jalali-moment/jalali-moment";
import { GiftedChat, Send } from "react-gifted-chat";
import trash from "../../assets/images/trash.png";
import { formatDate } from "../../_helpers/formatDate.js";
Modal.setAppElement("#root");

class IndicatorEop_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervals: [],
      IndicatorName: "",
      IndicatorNameBottom: "",
      title: "",
      eopModal: false,
      currentEop: {},
      currentInterval: {},
      eopVisitModal: false,
      measureInterval: "",
      per_page: 24,
      page: props.globalStorage.lastList
        ? props.globalStorage.lastList.page
        : 1,
      orderBy: props.globalStorage.lastList
        ? props.globalStorage.lastList.orderBy
        : "created_at",
      query: props.globalStorage.lastList
        ? props.globalStorage.lastList.query
        : "",
      desirability: "",
      lower_limit: "",
      upper_limit: "",
      detailModal: false,
      total_average: 0,
      selectedIndicator: "",
      indicator: "",
      formula: "",
      boxes: "",
      compacts: [],
      currentCompact: {},
      isCollector: true,
      formulaRecords: [],
      formulaRecordsWithColors: [],
      messages: [
        {
          _id: 1,
          text: "Hello developer",
          createdAt: new Date(),
          user: {
            _id: 2,
            name: "React Native",
            avatar: trash,
          },
        },
      ],
      commentsModal: false,
      currentDetail: 0,
      currentRecord: {},
      comments: [],
      kartablInfo: [],
      report_type: "",
      // indicator_lists: [],
      multiplier: 1,
      // requestSortTo
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount = () => {
    this.getData();
    this.getIndicatorName();
    this.getMeasureInterval();
    document.querySelector(".wave").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  getMeasureInterval = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v2/get_indicator_list?year=${this.globalStorage.year}&page=${this.state.page}&perpage=${this.state.per_page}&order=${this.state.orderBy}&by_query=${this.state.query}`,
          null,
          true
        )
      )
      .then((response) => {
        const indicatorId = this.props.getIndicatorId();
        const data = response.data.result.find((obj) => obj.id === indicatorId);
        this.setState({
          measureInterval: data.measure_interval,
          title: data.title,
          desirability: data.desirability,
          lower_limit: data.lower_limit,
          upper_limit: data.upper_limit,
        });
      });
  };

  getBackground = (interval) => {
    if (interval && interval.average !== undefined) {
      const { desirability, lower_limit, upper_limit } = this.state;
      if (lower_limit !== null && upper_limit !== null) {
        if (desirability === "افزاینده") {
          return interval.average < lower_limit
            ? "#ffc7d6"
            : interval.average >= upper_limit
            ? "#c4ffda"
            : "#ffffad";
        } else {
          return interval.average > lower_limit &&
            interval.average < upper_limit
            ? "#ffffad"
            : interval.average <= lower_limit
            ? "#c4ffda"
            : "#ffc7d6";
        }
      } else {
        return "#6c6c6c";
      }
    }

    return undefined;
  };

  getData = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `${
            userConstants.SERVER_URL
          }v2/get_indicator_interval_averages?indicator_id=${this.props.getIndicatorId()}`,
          null,
          true
        )
      )
      .then((response) => {
        this.setState({
          intervals: response.data.intervals.filter((interval) =>
            Object.hasOwn(interval, "eop")
          ),
        });
      });
  };

  getIndicatorName = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `${
            userConstants.SERVER_URL
          }v2/get_indicator_formula?indicator_id=${this.props.getIndicatorId()}`,
          null,
          true
        )
      )
      .then((response) => {
        this.setState({ IndicatorName: response.data.formula.numerator[0] });
      });
  };

  eopVisitPage = (i) => {
    const { intervals } = this.state;
    this.props.history.push(`eop_visit/${intervals[i].id}/${this.pageId}/${i}`);
  };

  goBack = () => {
    this.props.history.goBack();
  };
  getFormulaRecords = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `${
            userConstants.SERVER_URL
          }v2/indicator/answers/formula_records?interval_number=${
            this.state.currentInterval.interval_number
          }&indicator_id=${this.props.getIndicatorId()}&page=1&per=24&ward=`
        )
      )
      .then((response) => {
        this.setState({
          formulaRecords: response.data,
        });
      });
  };

  onSend = (messages) => {
    this.props
      .dispatch(
        userActions.API(
          "post",
          `v2/indicator/answers/formula_record_comments`,
          {
            id: this.state.currentRecord.id,
            text: messages[0].text,
            post: this.props.isCollector
              ? "مسئول اندازه گیری"
              : this.props.only_me
              ? "مسئول پایش"
              : "دبیر",
          }
        )
      )
      .then((res) => {
        this.setState({
          comments: [...this.state.comments, this.serializer(res.data)],
        });
      });
  };

  serializer = (c) => ({
    ...c,
    _id: c.id,
    text: c.text,
    createdAt: c.created_at,
    user: c.user
      ? {
          _id: c.user.id,
          name: c.user.firstname + " " + c.user.lastname,
          avatar: userConstants.SERVER_URL + c.user.avatar.url,
        }
      : {
          _id: c.user_id,
          name: c.firstname + " " + c.lastname,
          avatar: userConstants.SERVER_URL + c.avatar.url,
        },
  });

  showMessages = (item) => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v2/indicator/answers/formula_record_comments?id=${item.id}`
        )
      )
      .then((res) => {
        this.setState({
          currentRecord: item,
          // commentsModal: true,
          comments: res.data.result.map(this.serializer),
        });
      });
  };

  addNewLine = (text) => {
    return text.replace(/.{1,90}/g, "$&\n").slice(0, -3);
  };

  getBackground = (interval) => {
    if (interval && interval.average !== undefined) {
      const { desirability, lower_limit, upper_limit } = this.state;
      if (lower_limit !== null && upper_limit !== null) {
        if (desirability === "افزاینده") {
          return interval.average < lower_limit
            ? "#ffc7d6"
            : interval.average >= upper_limit
            ? "#c4ffda"
            : "#ffffad";
        } else {
          return interval.average > lower_limit &&
            interval.average < upper_limit
            ? "#ffffad"
            : interval.average <= lower_limit
            ? "#c4ffda"
            : "#ffc7d6";
        }
      } else {
        return "#ffffffd2";
      }
    }

    return undefined;
  };

  getBackground2 = (result) => {
    const { desirability, lower_limit, upper_limit } = this.state;
    let color;
    if (result !== "-") {
      if (lower_limit !== null && upper_limit !== null) {
        if (desirability === "افزاینده") {
          color =
            result < lower_limit
              ? "#ffc7d6"
              : result >= upper_limit
              ? "#c4ffda"
              : "#ffffad";
        } else {
          color =
            result > lower_limit && result < upper_limit
              ? "#ffffad"
              : result <= lower_limit
              ? "#c4ffda"
              : "#ffc7d6";
        }
        return color;
      } else {
        return "#ffffffd2";
      }
    } else {
      return "#ffffffd2";
    }
  };

  render() {
    return (
      <Container className="indicator-eop__container">
        <Card className="notif__card">
          <p>
            ثبت اقـدام اصلاحـی برای شاخص <span>{this.state.title}</span> در
            بـازه هـای زیـر شما مـی توانیـد بر روی بازه مورد نظر اقدام اصلاحـی
            ثبت کنیـد
          </p>
        </Card>
        <Container className="indicator_eop__container u-background-white ">
          <List>
            {this.state.intervals
              // .map((b) => b)
              .sort((a, b) => a.interval_number - b.interval_number)
              .map((_, i) => (
                <ListItem
                  i={i}
                  key={i + 1}
                  interval={this.state.intervals[i]}
                  eopPage={this.eopPage}
                  eopVisitPage={this.eopVisitPage}
                  measureInterval={this.state.measureInterval}
                  year={this.globalStorage.year}
                  onRequestOpenEop={() =>
                    this.setState({
                      eopModal: true,
                      currentEop: this.state.intervals[i].eop,
                      currentInterval: this.state.intervals[i],
                    })
                  }
                  onRequestOpenEopVisit={() =>
                    this.setState({
                      eopVisitModal: true,
                      currentEop: this.state.intervals[i].eop,
                    })
                  }
                  onRequestDetail={() => {
                    this.setState(
                      {
                        detailModal: !this.state.detailModal,
                        currentCompact: this.state.compacts[i],
                        currentInterval: this.state.intervals[i],
                      },
                      () => {
                        this.getFormulaRecords();
                      }
                    );
                  }}
                  backgroundColor={this.getBackground(this.state.intervals[i])}
                  report_type={this.state.report_type}
                />
              ))}
          </List>
          <button
            className="text-white btn-primary btn d-flex justify-content-center mx-auto rounded-pill btn_indicatorEop mt-3 py-3"
            onClick={this.props.onRequestClose}
          >
            بازگشت
          </button>
        </Container>
        <Modal
          isOpen={this.state.eopModal}
          shouldCloseOnOverlayClick={false}
          contentLabel="Detail Modal"
          portalClassName="full_screen_modal"
          d
        >
          <Eop
            onRequestClose={() => this.setState({ eopModal: false })}
            eopData={this.state.currentEop}
            intervalData={this.state.currentInterval}
            refreshIndicatorEop={this.getData}
          />
        </Modal>
        <Modal
          isOpen={this.state.eopVisitModal}
          shouldCloseOnOverlayClick={false}
          contentLabel="Detail Modal"
          portalClassName="full_screen_modal"
          d
        >
          <EopVisit
            onRequestClose={() => this.setState({ eopVisitModal: false })}
            eopData={this.state.currentEop}
          />
        </Modal>
        <Modal
          isOpen={this.state.detailModal}
          shouldCloseOnOverlayClick={true}
          contentLabel="User Modal"
          portalClassName="full_screen_modal detailModal"
        >
          <Container className="indicator_eop__container u-background-white ">
            <List2>
              <Banner2
                IndicatorName={this.state.IndicatorName}
                IndicatorNameBottom={this.state.IndicatorNameBottom}
              />
              {this.state.formulaRecords
                .slice()
                .sort((a, b) => {
                  const { desirability, lower_limit, upper_limit } = this.state;
                  let resA, resB;

                  const resultA =
                    a.numerator[0] === 0 && a.denumrator[0] === 0
                      ? "-"
                      : (a.numerator[0] / a.denumrator[0]) *
                        Number(this.state.multiplier);
                  const resultB =
                    b.numerator[0] === 0 && b.denumrator[0] === 0
                      ? "-"
                      : (b.numerator[0] / b.denumrator[0]) *
                        Number(this.state.multiplier);

                  if (lower_limit !== null && upper_limit !== null) {
                    if (desirability === "افزاینده") {
                      resA =
                        resultA === "-"
                          ? -1
                          : resultA < lower_limit
                          ? 2
                          : resultA >= upper_limit
                          ? 0
                          : 1;

                      resB =
                        resultB === "-"
                          ? -1
                          : resultB < lower_limit
                          ? 2
                          : resultB >= upper_limit
                          ? 0
                          : 1;
                    } else {
                      resA =
                        resultA === "-"
                          ? -1
                          : resultA > lower_limit && resultA < upper_limit
                          ? 1
                          : resultA <= lower_limit
                          ? 0
                          : 3;

                      resB =
                        resultB === "-"
                          ? -1
                          : resultB > lower_limit && resultB < upper_limit
                          ? 1
                          : resultB <= lower_limit
                          ? 0
                          : 3;
                    }
                  }

                  return resB - resA;
                })
                .map((record, i) => (
                  <ListItem2
                    i={i}
                    key={i + 1}
                    record={record}
                    multiplier={+this.state.multiplier}
                    interval={this.state.currentInterval}
                    measureInterval={this.state.measureInterval}
                    getFormulaRecords={this.getFormulaRecords}
                    getBackground2={this.getBackground2}
                    config={{
                      headers: {
                        Authorization: this.globalStorage.token,
                      },
                    }}
                    dispatch={this.props.dispatch}
                    onRequestOpenChatModal={() =>
                      this.setState(
                        { commentsModal: true, currentDetail: i },
                        () =>
                          this.showMessages(
                            this.state.formulaRecords[this.state.currentDetail]
                          )
                      )
                    }
                  />
                ))}
            </List2>
            <button
              className="text-white btn-primary btn d-flex justify-content-center mx-auto rounded-pill btn_indicatorEop mt-3 py-3"
              onClick={() =>
                this.setState({ detailModal: !this.state.detailModal })
              }
            >
              بازگشت
            </button>
          </Container>

          <Modal
            isOpen={this.state.commentsModal}
            shouldCloseOnOverlayClick={false}
            portalClassName="full_screen_modal chatModal"
          >
            <div className="bg-drr container pb-5 pt-1 h-100 rounded-lg dirLTR text-right">
              <button
                className="btn btn-link text-danger"
                onClick={() => this.setState({ commentsModal: false })}
              >
                <i className="fa fa-times" />
              </button>
              <GiftedChat
                renderSend={(props) => (
                  <Send {...props}>
                    <BtnRound
                      data_tip="ارسال"
                      className="send-icon"
                      onClick={this.props.onRequestOpenEop}
                    />
                  </Send>
                )}
                renderAvatar={(item) => {
                  return (
                    <>
                      <div
                        className="overflow_image rounded-circle mx-auto my-2"
                        style={{ width: 40, height: 40 }}
                      >
                        <img
                          src={item.currentMessage.user.avatar}
                          className=""
                        />
                      </div>
                      <small style={{ fontSize: ".8em" }}>
                        {item.currentMessage.user.name}
                      </small>
                    </>
                  );
                }}
                renderAllAvatars={true}
                renderDay={(itm) => {
                  if (
                    itm.previousMessage &&
                    itm.previousMessage.createdAt &&
                    moment(itm.currentMessage.createdAt).isSame(
                      moment(itm.previousMessage.createdAt),
                      "d"
                    )
                  ) {
                    return <></>;
                  } else {
                    return (
                      <p className="text-muted text-center">
                        {moment(itm.currentMessage.createdAt)
                          .clone()
                          .locale("fa")
                          .format("dddd DD MMMM YYYY")}
                      </p>
                    );
                  }
                }}
                renderTime={(item) => (
                  <small
                    className="text-white-50 px-2 text-right"
                    style={{ fontSize: ".7em" }}
                  >
                    {(item.currentMessage.post || "") + " - "}{" "}
                    {moment(item.currentMessage.createdAt).format("HH:mm")}
                  </small>
                )}
                placeholder="متن شما ..."
                messages={[...this.state.comments].reverse()}
                onSend={(messages) => {
                  this.onSend(
                    messages.map((msg) => {
                      return {
                        ...msg,
                        text: this.addNewLine(msg.text),
                      };
                    })
                  );
                }}
                user={{
                  _id: this.props.globalStorage.me
                    ? this.props.globalStorage.me.id
                    : "",
                }}
              />
            </div>
          </Modal>
        </Modal>
      </Container>
    );
  }
}

class Card extends Component {
  render() {
    return (
      <div className={`${this.props.className}`}>{this.props.children}</div>
    );
  }
}

class Container extends Component {
  render() {
    return (
      <div className={`${this.props.className}`}>{this.props.children}</div>
    );
  }
}
class List2 extends Component {
  render() {
    return <ul className="indicator_eop__list">{this.props.children}</ul>;
  }
}

class Banner2 extends Component {
  render() {
    return (
      <li className="detail_modal__list__banner" key="0">
        <div className="detail_modal__list__banner__child">ردیف</div>
        <div className="detail_modal__list__banner__child">دوره ارزیابی</div>
        <div className="detail_modal__list__banner__child">تاریخ ثبت</div>
        <div className="detail_modal__list__banner__child">نام بخش</div>
        <div className="detail_modal__list__banner__child">
          مسئول اندازه گیری
        </div>
        <div className="detail_modal__list__banner__child">
          <p className="detail_modal__list__banner__special-child">
            <span>صورت</span>
            <span>{`(${this.props.IndicatorName})`}</span>
          </p>
        </div>
        <div className="detail_modal__list__banner__child">
          <p className="detail_modal__list__banner__special-child">
            <span>مخرج</span>
            <span>{`(${this.props.IndicatorNameBottom})`}</span>
          </p>
        </div>
        <div className="detail_modal__list__banner__child">عدد شاخص</div>
        <div className="detail_modal__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem2 extends Component {
  render() {
    const { i, interval, measureInterval, year, multiplier, getBackground2 } =
      this.props;
    const { interval_number, average } = interval;
    const {
      created_at,
      denumrator,
      id,
      menu_items,
      numerator,
      seen,
      user,
      ward,
    } = this.props.record;
    const months = [
      "فروردین",
      "اردیبهشت",
      "خرداد",
      "تیر",
      "مرداد",
      "شهریور",
      "مهر",
      "آبان",
      "آذر",
      "دی",
      "بهمن",
      "اسفند",
    ];
    const threeMonth = [
      "سه ماهه اول",
      "سه ماهه دوم",
      "سه ماهه سوم",
      "سه ماهه چهارم",
    ];
    const sixMonth = ["شش ماهه اول", "شش ماهه دوم"];
    const averageText = average % 1 ? average.toFixed(2) : average;
    const findMonthOfDailyInterval =
      interval_number < 32
        ? 1
        : interval_number < 63
        ? 2
        : interval_number < 94
        ? 3
        : interval_number < 125
        ? 4
        : interval_number < 155
        ? 5
        : interval_number < 186
        ? 6
        : interval_number < 216
        ? 7
        : interval_number < 246
        ? 8
        : interval_number < 276
        ? 9
        : interval_number < 306
        ? 10
        : interval_number < 336
        ? 11
        : interval_number < 366
        ? 12
        : 0;
    const DailyIntervalText = `${
      findMonthOfDailyInterval === 1
        ? interval_number
        : interval_number -
          (findMonthOfDailyInterval - 1) *
            (findMonthOfDailyInterval < 7 ? 31 : 30)
    } ${months[findMonthOfDailyInterval - 1]}`;
    const result =
      numerator[0] === 0 && denumrator[0] === 0
        ? "-"
        : (numerator[0] / denumrator[0]) * multiplier;
    const backgroundColor = getBackground2(result);

    return (
      <li
        className={`detail_modal__list__item`}
        style={{ background: backgroundColor }}
      >
        <p className="detail_modal__list__item__text">{i + 1}</p>
        <p className="detail_modal__list__item__text">
          {measureInterval === "روزانه"
            ? DailyIntervalText
            : measureInterval === "ماهانه"
            ? months[interval_number - 1]
            : measureInterval === "سه ماه یکبار"
            ? threeMonth[interval_number - 1]
            : measureInterval === "شش ماه یکبار"
            ? sixMonth[interval_number - 1]
            : measureInterval === "سالانه"
            ? `سال ${year}`
            : "xxx"}
        </p>
        <p className="detail_modal__list__item__text">
          {formatDate(created_at)}
        </p>
        <p className="detail_modal__list__item__text">{ward}</p>
        <p className="detail_modal__list__item__text">{user}</p>
        <p className="detail_modal__list__item__text">{numerator[0]}</p>
        <p className="detail_modal__list__item__text">{denumrator[0]}</p>
        <p className="detail_modal__list__item__text">
          {result % 1 ? result.toFixed(2) : result}
        </p>
        <ListItemBtnContainer>
          <BtnRound
            data_tip="مکاتبات"
            className="doctor-icon"
            onClick={this.props.onRequestOpenChatModal}
          />
          <ReactTooltip type="dark" />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class List extends Component {
  render() {
    return (
      <ul className="indicator_eop__list">
        <Banner />
        {this.props.children}
      </ul>
    );
  }
}

class Banner extends Component {
  render() {
    return (
      <li className="indicator_eop__list__banner" key="0">
        <div className="indicator_eop__list__banner__child">ردیف</div>
        <div className="indicator_eop__list__banner__child">دوره ارزیابی</div>
        <div className="indicator_eop__list__banner__child">امتیاز</div>
        <div className="indicator_eop__list__banner__child">جزئیات</div>
        <div className="indicator_eop__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    if (this.props.interval === undefined) return null;

    const { i, interval, measureInterval, year, report_type } = this.props;
    const { id, interval_number, average, has_eop } = interval;
    const months = [
      "فروردین",
      "اردیبهشت",
      "خرداد",
      "تیر",
      "مرداد",
      "شهریور",
      "مهر",
      "آبان",
      "آذر",
      "دی",
      "بهمن",
      "اسفند",
    ];
    const threeMonth = [
      "سه ماهه اول",
      "سه ماهه دوم",
      "سه ماهه سوم",
      "سه ماهه چهارم",
    ];
    const sixMonth = ["شش ماهه اول", "شش ماهه دوم"];
    const averageText = average % 1 ? average.toFixed(2) : average;
    const findMonthOfDailyInterval =
      interval_number < 32
        ? 1
        : interval_number < 63
        ? 2
        : interval_number < 94
        ? 3
        : interval_number < 125
        ? 4
        : interval_number < 155
        ? 5
        : interval_number < 186
        ? 6
        : interval_number < 216
        ? 7
        : interval_number < 246
        ? 8
        : interval_number < 276
        ? 9
        : interval_number < 306
        ? 10
        : interval_number < 336
        ? 11
        : interval_number < 366
        ? 12
        : 0;
    const DailyIntervalText = `${
      findMonthOfDailyInterval === 1
        ? interval_number
        : interval_number -
          (findMonthOfDailyInterval - 1) *
            (findMonthOfDailyInterval < 7 ? 31 : 30)
    } ${months[findMonthOfDailyInterval - 1]}`;

    return (
      <li
        className={`indicator_eop__list__item`}
        style={{ background: this.props.backgroundColor }}
      >
        <p className="indicator_eop__list__item__text">{i + 1}</p>
        <p className="indicator_eop__list__item__text">
          {measureInterval === "روزانه"
            ? DailyIntervalText
            : measureInterval === "ماهانه"
            ? months[interval_number - 1]
            : measureInterval === "سه ماه یکبار"
            ? threeMonth[interval_number - 1]
            : measureInterval === "شش ماه یکبار"
            ? sixMonth[interval_number - 1]
            : measureInterval === "سالانه"
            ? `سال ${year}`
            : "xxx"}
        </p>
        <p className="indicator_eop__list__item__text">
          {measureInterval === "روزانه" ? "-" : averageText}
        </p>
        <ListItemBtnContainer>
          {report_type !== "چک لیست" ? (
            <BtnRound
              data_tip="مشاهده جزئیات"
              className="document-icon"
              onClick={this.props.onRequestDetail}
            />
          ) : (
            <BtnRound
              className="document-dark-icon"
              data_tip="مشاهده جزئیات (بزودی)"
              onClick={() => ""}
            />
          )}
          <ReactTooltip type="dark" />
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          {has_eop ? (
            <BtnRound
              data_tip="مشاهده اقدامات اصلاحی"
              className="more-icon"
              onClick={this.props.onRequestOpenEopVisit}
            />
          ) : (
            ""
          )}
          <BtnRound
            data_tip={has_eop ? "ویرایش" : "ثبت اقدام اصلاحی"}
            className="goal-icon"
            onClick={this.props.onRequestOpenEop}
          />
          <ReactTooltip type="dark" />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <button
        className={`btn-round ${this.props.className}`}
        onClick={this.props.onClick}
        data-tip={this.props.data_tip}
      ></button>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="indicator_eop__list__item__btn-container">
        {this.props.children}
      </div>
    );
  }
}

const IndicatorEop = connect((state) => ({
  globalStorage: state.globalStorage,
}))(IndicatorEop_);

export { IndicatorEop };
